import React, { useRef, useState } from "react";
import { toast } from "sonner";
import { FileText, Upload, Download, Loader2 } from "lucide-react";
import { adminApi } from "../../lib/api";

const Resume = () => {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const [v, setV] = useState(0); // bust preview cache after upload

  const onFile = async (file) => {
    if (!file) return;
    if (file.type !== "application/pdf") {
      toast.error("Please upload a PDF");
      return;
    }
    setBusy(true);
    try {
      await adminApi.uploadResume(file);
      toast.success("Resume replaced");
      setV((x) => x + 1);
    } catch {
      toast.error("Upload failed");
    } finally {
      setBusy(false);
    }
  };

  const previewUrl = `/Soumyajit_Raj_Resume.pdf?v=${v}`;

  return (
    <div className="space-y-5">
      <div>
        <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-cyan-300 mb-1">CMS</div>
        <h1 className="font-display text-3xl text-white font-medium">Resume</h1>
        <p className="text-slate-400 text-sm mt-1">Replace the downloadable PDF served at <code className="text-cyan-300 font-mono text-xs">/Soumyajit_Raj_Resume.pdf</code></p>
      </div>

      <div className="glass rounded-2xl p-6 flex flex-col sm:flex-row sm:items-center gap-5">
        <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-cyan-400/10 to-violet-500/10 border border-white/10 grid place-items-center">
          <FileText size={22} className="text-cyan-300" />
        </div>
        <div className="flex-1">
          <div className="text-white font-medium">Current resume</div>
          <div className="text-sm text-slate-500">Served from public folder. Hot-swap with a new PDF below.</div>
        </div>
        <div className="flex items-center gap-2">
          <a href={previewUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 px-4 py-2 rounded-full glass text-white text-sm hover:border-cyan-400/40">
            <Download size={14} /> Open
          </a>
          <input ref={inputRef} type="file" accept="application/pdf" className="hidden" onChange={(e) => onFile(e.target.files?.[0])} />
          <button
            onClick={() => inputRef.current?.click()}
            disabled={busy}
            data-testid="admin-resume-upload"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-cyan-400 to-violet-500 text-black text-sm font-medium disabled:opacity-70"
          >
            {busy ? <Loader2 size={14} className="animate-spin" /> : <Upload size={14} />} Upload PDF
          </button>
        </div>
      </div>

      <div className="glass rounded-2xl p-3">
        <iframe key={v} title="Resume preview" src={previewUrl} className="w-full h-[70vh] rounded-xl bg-black" />
      </div>
    </div>
  );
};

export default Resume;
